import { Tab } from "bootstrap";
import * as appState from "./ac101-app.js";

export class AC101FiltersModal extends HTMLElement {
  
  #handleChange(e) {
    const currentTarget = e.target.getAttribute("data-bs-target");
    const listingType = currentTarget.replace("#", "").replace("-tab-pane", "");
    appState.listingType.set(listingType);
  }


  connectedCallback() {

    for (const element of document.querySelectorAll("[data-bs-target]")) {
      element.removeEventListener("shown.bs.tab", this.#handleChange);
      element.addEventListener("shown.bs.tab", this.#handleChange);
    }

    const selector = `#${appState.listingType.get()}-tab`;
    const element = document.querySelector(selector);
    const instance = Tab.getOrCreateInstance(element);
    requestAnimationFrame(() => {
      instance?.show();
    });

    appState.listingType.subscribe(() => {
      const selector = `#${appState.listingType.get()}-tab`;
      const element = document.querySelector(selector);
      const instance = Tab.getOrCreateInstance(element);
      instance?.show();
      const select = this.querySelector<HTMLSelectElement>("#filters-modal-select");
      console.log({ select });
      if (select) {
        select.querySelector(`option`)?.removeAttribute("selected");
        select.value = appState.listingType.get();
      }
    })

  }
}

customElements.define('ac101-filters-modal', AC101FiltersModal);